module.exports = __webpack_public_path__ + "static/media/averta.aafdb27b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta.woff2
// module id = 843
// module chunks = 4